import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TimeFilter } from "enums/transaction";
import { ApplicationRootState } from "types";
import { MemberStateType } from "types/memberVip";

import { extraReducers } from "./member.extraReducer";
export const initialState: MemberStateType = {
  isLoading: false,
  dataMemberVip: {
    data: {
      total_level: 0,
      current_level: 0,
      next_level: {
        current_deposit: "",
        deposit: "",
        level: 0,
        turnover: "",
        current_turnover: "",
        turnover_percentage: "",
      },
      benefit: {
        birthday_bonus: "",
        upgrade_reward: "",
      },
      rebate: {
        "": "",
      },
      board: [
        {
          id: "",
          name: "",
          total_valid_bet: "",
          level_up_bonus: "",
          accumulate_level_reward: "",
          montly_bonus: "",
          weekly_bonus: "",
          withdraw_limit: "",
          total_withdraw: "",
          number_withdraw: "",
          max_turnover: "",
          max_deposit: "",
          birthday_bonus: "",
        },
      ],
      history: [
        {
          previous_level: "",
          to_level: "",
          bet: "",
          date: "",
        },
      ],
    },
    filter: TimeFilter.TODAY,
    filterStatus: "all",
  },
  dataAwardVip: {
    isLoadingAward: false,
    data: [
      {
        id: "",
        old_level: "",
        new_level: "",
        bet_amount: "",
        bonus: "",
        status: "",
        date: "",
      },
    ],
  },
};

const memberSlice = createSlice({
  name: "memberVip",
  initialState,
  reducers: {
    //
    updateVipFilter(
      state: MemberStateType,
      { payload }: PayloadAction<TimeFilter>,
    ) {
      state.dataMemberVip.filter = payload;
    },
    updateVipFilterStatus(
      state: MemberStateType,
      { payload }: PayloadAction<string>,
    ) {
      state.dataMemberVip.filterStatus = payload;
    },
  },
  extraReducers,
});

export const selectLoadingDataMemberVip = (state: ApplicationRootState) =>
  state.memberVip.isLoading;

export const selectLoadingDataAwardVip = (state: ApplicationRootState) =>
  state.memberVip.dataAwardVip.isLoadingAward;

export const selectDataMemberVip = (state: ApplicationRootState) =>
  state.memberVip.dataMemberVip;

export const selectDataAwardVip = (state: ApplicationRootState) =>
  state.memberVip.dataAwardVip;

export const selectFilterVip = (state: ApplicationRootState) =>
  state.memberVip.dataMemberVip.filter;

export const selectFilterStatus = (state: ApplicationRootState) =>
  state.memberVip.dataMemberVip.filterStatus;

export const { updateVipFilter, updateVipFilterStatus } = memberSlice.actions;

export default memberSlice.reducer;
